export enum ACTIVITY_TYPE {
  TOPICAL_CALENDAR = "TOPICAL_CALENDAR",
  TASK = "TASK",
  POST = "POST",
  DRAFT_POST = "DRAFT_POST",
  POST_GROUP = "POST_GROUP"
}
